import React from 'react';

// Ref: https://medium.com/@seanmcp/%EF%B8%8F-how-to-use-emojis-in-react-d23bbf608bf7

type EmojiProps = {
  label?: string;
  symbol: string;
};

function Emoji(props: EmojiProps) {
  return (
    <span
      aria-hidden={props.label ? 'false' : 'true'}
      aria-label={props.label ? props.label : ''}
      role="img"
    >
      {props.symbol}
    </span>
  );
}

export default Emoji;
